var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightDarkGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5867 0.243324C6.26227 -0.0811079 5.73626 -0.0811079 5.41182 0.243324C5.08739 0.567756 5.08739 1.09378 5.41182 1.41821L9.16321 5.16958L0.830767 5.16958C0.37194 5.16958 0 5.54153 0 6.00035C0 6.45918 0.37194 6.83112 0.830767 6.83112L9.16243 6.83112L5.41182 10.5817C5.08739 10.9062 5.08739 11.4322 5.41182 11.7567C5.73626 12.0811 6.26227 12.0811 6.5867 11.7567L11.7308 6.61255C11.8962 6.46068 12 6.24264 12 6.00035C12 5.7635 11.9009 5.54981 11.7418 5.39848L6.5867 0.243324Z",
    fill: "#042916"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDarkGreen);
export default __webpack_public_path__ + "static/media/arrow-right-dark-green.bb90767f1facf6ba2951af34f37681c2.svg";
export { ForwardRef as ReactComponent };